module.exports = __webpack_public_path__ + "static/media/aladdin_snes_castle.322dcb58.png";